module.exports = __webpack_public_path__ + "img/coin.b2715bad.png";